import { render } from "./rules-text.vue?vue&type=template&id=43a6a136"
import script from "./rules-text.vue?vue&type=script&lang=js"
export * from "./rules-text.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kurlov/WebstormProjects/2024/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__